import createTemplateService from './createTemplateServjce';
const projectListTemplateService = createTemplateService('/project_list_templates');
export default projectListTemplateService;